module.exports = __webpack_public_path__ + "src/img/whattodo3.jpg?13c0fef6e119da719a42c3d6c8e0e779";


//////////////////
// WEBPACK FOOTER
// ./src/img/whattodo3.jpg
// module id = 214
// module chunks = 0